import { Link } from '@tanstack/react-router'
import { t } from '@najah/i18n'

export function NotFoundPage() {
  return (
    <div className="grid min-h-[60dvh] place-items-center px-4 text-center">
      <div>
        <p className="font-display text-6xl font-bold text-primary/25" dir="ltr">404</p>
        <h1 className="mt-4 text-xl font-semibold text-fg">{t.errors.notFound}</h1>
        <p className="mt-1.5 text-sm text-fg-muted">{t.errors.notFoundDesc}</p>
        <Link
          to="/"
          className="mt-6 inline-flex h-10 items-center rounded-lg bg-primary px-4 text-sm font-medium text-fg-on-primary transition-colors hover:bg-primary-hover"
        >
          {t.errors.goHome}
        </Link>
      </div>
    </div>
  )
}
